import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const ArrowIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <path d="m8.471 2.862 4.667 4.667.013.013a.67.67 0 0 1 .046.053l-.059-.066a.67.67 0 0 1 .152.708.658.658 0 0 1-.152.234l-4.667 4.667a.667.667 0 0 1-.942-.943l3.527-3.528H3.333a.667.667 0 0 1 0-1.334h7.723L7.529 3.805a.667.667 0 0 1-.056-.88l.056-.063c.26-.26.682-.26.942 0z" fil-rule="nonzero" />
    </SvgIcon>
  );
};
